import { MdbError } from "../../../errorObjects/MdbError";
import { enumMdbErrorType } from "../../../errorObjects/enums";

/**
 * @function getBaseStoragePathWithoutFilename Given a baseStoragePath, extracts and returns the path without the trailing filename
 * @param {string} baseStoragePath The base storage path of the file in CloudStorage, including the filename, but without server name, security adornments, etc.
 * @returns {string} The base storage path without the trailing filename.
 * @example Given a baseStoragePath of 'userFiles/3io899/imageFiles/GhxIO23/img_005.jpg', the function will return 'userFiles/3io899/imageFiles/GhxIO23'
 */
export function getBaseStoragePathWithoutFilename(baseStoragePath: string): string {
  // locate the character index of the last forward slash ('/') in the baseStoragePath
  const indexOfFilenameSegment: number = baseStoragePath.lastIndexOf('/');

  if (indexOfFilenameSegment !== -1) {
    // obtain the substring of the baseStoragePath up to (preceding) the last forward slash
    const pathUpToFilenameSegment: string = baseStoragePath.substr(0, indexOfFilenameSegment);

    // return the substring
    return pathUpToFilenameSegment;
  } else {
    throw new MdbError(`baseStoragePath ('${baseStoragePath}') does not have the proper format for a Cloud Storage file`, enumMdbErrorType.DataFormatInvalid);
  }

}